import React from 'react'
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/react'

export interface TabItem {
  key: string
  label: React.ReactNode
  content: React.ReactNode
  disabled?: boolean
}

export interface TabsProps {
  items: TabItem[]
  defaultIndex?: number
  selectedIndex?: number
  onChange?: (index: number) => void
  'data-testid'?: string
}

const Tabs = ({
  items,
  defaultIndex = 0,
  selectedIndex,
  onChange,
  'data-testid': testId,
}: TabsProps) => {
  const isControlled = selectedIndex !== undefined
  const [uncontrolledIndex, setUncontrolledIndex] = React.useState(defaultIndex)

  const activeIndex = isControlled ? selectedIndex : uncontrolledIndex

  const handleChange = (index: number) => {
    if (!isControlled) {
      setUncontrolledIndex(index)
    }
    onChange?.(index)
  }

  return (
    <TabGroup
      selectedIndex={activeIndex}
      onChange={handleChange}
      data-testid={testId}
    >
      <TabList className="border-b border-border-token overflow-x-auto sm:overflow-visible">
        {items.map((item) => (
          <Tab
            key={item.key}
            disabled={item.disabled}
            className={({ selected }) =>
              `px-4 py-2 border-b-2 font-medium transition-colors ${
                selected
                  ? 'border-interactive text-ink'
                  : 'border-transparent text-ink-muted hover:text-ink'
              }`
            }
          >
            {item.label}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {items.map((item) => (
          <TabPanel key={item.key}>
            {item.content}
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  )
}

export default Tabs
